export { default as styledButton } from 'styled-components'
